import { Instance, types } from 'mobx-state-tree';

const AccountPayable = types.model({
  accountPayableId: types.string,
  paymentId: types.string,
  refNumber: types.string,
  businessName: types.string,
  amount: types.optional(types.union(types.number, types.string), ''),
  currency: types.string,
  clabe: types.string,
  category: types.optional(types.string, ''),
  type: types.optional(types.string, ''),
  class: types.optional(types.string, ''),
  department: types.optional(types.string, ''),
  project: types.optional(types.string, ''),
  payableType: types.optional(types.string, ''),
  payableSubType: types.optional(types.string, ''),
  paymentConcept: types.optional(types.string, ''),
  reference: types.optional(types.string, ''),
  error: types.optional(types.string, ''),
  cepUrl: types.optional(types.string, ''),
});

export interface IAccountPayable extends Instance<typeof AccountPayable> {}
export default AccountPayable;
